const DownloadLauncherHost = {
	dev: 'https://dev-download.d.nexon.io/download-launcher',
	testPre: 'https://test-download.nxfs.nexon.com/download-launcher',
	test: 'https://test-download.nxfs.nexon.com/download-launcher',
	pre: 'https://pre-download.nxfs.nexon.com/download-launcher',
	prod: 'https://download.nxfs.nexon.com/download-launcher',
};

const DownloadMacLauncherHost = {
	dev: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
	testPre: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
	test: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
	pre: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
	prod: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
};

export default { DownloadLauncherHost, DownloadMacLauncherHost };
export { DownloadLauncherHost, DownloadMacLauncherHost };
